import React from 'react';

export default (props) => {
    return (
        <table className="table table-striped table-hover table-sm">
            <thead>
                <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Count</th>
                </tr>
            </thead>
            <tbody>
                {Object.keys(props.counts).map(
                    date => {
                        return (
                            <tr key={date}>
                                <td>{date}</td>
                                <td>{props.counts[date].length}</td>
                            </tr>
                        );
                    }
                )}
            </tbody>
        </table>
    );
}
